import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    Drawer,
    notification,
    Row,
    Select,
    Table,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import {
    InputBox,
} from '../../../components/_utils/appUtils'
import { updateCourierApi } from '../api/subscriptionEdits'
import Request from '../../../request'

const { Option } = Select

@Form.create()
class EditCourierDrawer extends PureComponent {
    events = {
        removeCourierDetail: (index) => {
            let cloneArr = _.clone(this.state.courierDetails)
            cloneArr.splice(index, 1)
            this.setState({
                courierDetails: cloneArr
            })
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            journal: undefined,
            volumeName: undefined,
            issues: undefined,
            copies: undefined,

            courierDetails: [],
            journalNameList: [],
            journalVolumeList: [],
            journalIssueList: [],
            loading: false
        }
    }

    componentDidMount() {
        this.getJournalList()
        if (this.props.data) {
            this.initializeData(this.props.data)
        }
    }

    componentDidUpdate(prevProps) {
        // If visible changed from false to true OR data changed while visible
        if ((this.props.visible && !prevProps.visible) || (this.props.visible && this.props.data !== prevProps.data)) {
            if (this.props.data) {
                this.initializeData(this.props.data)
            }
        }
    }

    initializeData = (data) => {
        console.log('DEBUG: initializeData called with:', data)
        console.log('DEBUG: data.date =', data.date)
        console.log('DEBUG: data.mode =', data.mode)
        console.log('DEBUG: data.trackingNo =', data.trackingNo)
        console.log('DEBUG: data.TrackingNo =', data.TrackingNo)
        console.log('DEBUG: All keys in data:', Object.keys(data))

        // Populate form fields
        const { form } = this.props

        // Update state immediately
        this.setState({
            courierDetails: data.courierDetails ? _.cloneDeep(data.courierDetails) : []
        })

        // Use setTimeout to ensure form fields are rendered before setting values
        setTimeout(() => {
            form.setFieldsValue({
                date: data.date ? moment(data.date) : null,
                mode: data.mode,
                TrackingNo: data.TrackingNo || data.trackingNo  // Try both field names
            })
        }, 0)
    }

    getJournalList = async () => {
        try {
            let response = await Request.journalName()
            let rawData = response.data || response
            let dataList = Array.isArray(rawData) ? rawData : (rawData.data || rawData.result || [])

            let journalList = []
            if (Array.isArray(dataList)) {
                _.each(dataList, item => {
                    journalList.push({
                        _id: item._id,
                        value: item._id,
                        name: item.name
                    })
                })
            }
            this.setState({ journalNameList: journalList })
        } catch (e) { console.error(e) }
    }

    getJournalsVolumeData = async (id) => {
        try {
            let response = await Request.getJournalsVolumeList({ journalId: id })
            let rawData = response.data || response
            let dataList = Array.isArray(rawData) ? rawData : (rawData.data || rawData.result || [])

            let volumeList = []
            if (Array.isArray(dataList)) {
                _.each(dataList, (item) => {
                    if (item) {
                        volumeList.push({
                            _id: item._id,
                            name: item.volumeName,
                            display: item.volumeName
                        })
                    }
                })
            }
            this.setState({ journalVolumeList: volumeList })
        } catch (error) {
            console.error('Error in getJournalsVolumeData:', error)
            this.setState({ journalVolumeList: [] })
        }
    }

    getJournalsIssueData = params => {
        return new Promise(async resolve => {
            try {
                const { form: { getFieldValue } } = this.props
                let journalValue = getFieldValue('journal')
                const journalObj = this.state.journalNameList.find(j => j.name === journalValue || j._id === journalValue)
                const journalId = journalObj ? journalObj._id : journalValue
                // Need ID for API
                const volumeObj = this.state.journalVolumeList.find(v => v.name === params)
                const volumeId = volumeObj ? volumeObj._id : undefined

                if (!journalId || !volumeId) {
                    resolve()
                    return
                }

                let response = await Request.getJournalIssue({ journalId: journalId, volumeId: volumeId })
                let rawData = response.data || response
                let dataList = Array.isArray(rawData) ? rawData : (rawData.data || rawData.result || [])

                let issueList = []
                _.each(dataList, (item) => {
                    if (item) {
                        issueList.push({
                            _id: item._id,
                            name: item.issueName,
                            display: item.issueName
                        })
                    }
                })
                this.setState({ journalIssueList: issueList })
                resolve()
            } catch (error) {
                console.error('Error in getJournalsIssueData:', error)
                this.setState({ journalIssueList: [] })
                resolve()
            }
        })
    }

    async AddCourierDetails() {
        const {
            form: { getFieldValue, setFieldsValue }
        } = this.props
        let journal = getFieldValue('journal')
        let copies = getFieldValue('copies')
        let volumeName = getFieldValue('volumeName')
        let issues = getFieldValue('issues')

        if (!journal) {
            notification.error({ message: 'Please choose Journal Name.' })
            return
        }
        if (!copies) {
            notification.error({ message: 'Please select copies' })
            return
        }
        if (!volumeName) {
            notification.error({ message: 'Please select volume' })
            return
        }
        if (!issues) {
            notification.error({ message: 'Please select issues' })
            return
        }

        let obj = {
            journal: journal,
            copies: copies,
            volumeName: volumeName,
            issues: issues
        }

        // Check for duplicates
        let cloneD = _.clone(this.state.courierDetails)
        const isDuplicate = cloneD.some(item =>
            (item.journal === journal || item.journalId === journal) && // Handle if it's stored as ID vs Name
            item.volumeName === volumeName &&
            _.isEqual(item.issues ? item.issues.sort() : [], issues.sort())
        )

        if (isDuplicate) {
            notification.error({ message: 'This entry already exists.' })
            return
        }

        this.setState({ courierDetails: [...cloneD, obj] })

        // Reset fields
        setFieldsValue({
            journal: undefined,
            volumeName: undefined,
            issues: undefined,
            copies: undefined
        })
        this.setState({
            journalVolumeList: [],
            journalIssueList: []
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({ loading: true })

                const payload = {
                    courierId: this.props.data._id,
                    date: values.date ? values.date.format('YYYY-MM-DD') : null,
                    mode: values.mode,
                    trackingNo: values.trackingNo,
                    courierDetails: this.state.courierDetails
                }

                const { error } = await updateCourierApi(payload)
                this.setState({ loading: false })

                if (!error) {
                    notification.success({ message: "Courier Updated Successfully" })
                    this.props.onSuccess()
                    this.props.onClose()
                } else {
                    notification.error({ message: "Failed to update courier" })
                }
            }
        })
    }

    render() {
        const {
            form: { getFieldDecorator, setFieldsValue },
            data,
            visible,
            onClose
        } = this.props

        if (!visible) return null

        const initialDate = data && data.date ? moment(data.date) : null
        const initialMode = data ? data.mode : ''
        const initialTracking = data ? data.trackingNo : '' // Assuming trackingNo is in data

        const formItemLayout = {
            labelCol: { xs: { span: 24 }, sm: { span: 24 }, md: { span: 24 } },
            wrapperCol: { xs: { span: 24 }, sm: { span: 24 }, md: { span: 24 } }
        }

        const inputSchma = {
            fields: [
                {
                    label: 'Date',
                    key: 'date',
                    required: true,
                    placeholder: 'Date',
                    type: 'date'
                },
                {
                    label: 'Mode',
                    key: 'mode',
                    required: true,
                    placeholder: 'Mode'
                },
                {
                    title: 'Tracking No',
                    name: 'TrackingNo',
                    key: 'TrackingNo',
                    required: false,
                    placeholder: 'Tracking No',
                }
            ],
            multiFields: [
                {
                    label: 'Journal Name',
                    key: 'journal',
                    placeholder: 'Select',
                    type: 'select',
                    // required: true, // Not required for main submission, but required for "Add" button
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.name,
                    options: this.state.journalNameList,
                    onChange: (e) => {
                        setFieldsValue({ journal: e })
                        const selectedObj = this.state.journalNameList.find(j => j.name === e || j._id === e)
                        if (selectedObj) {
                            this.getJournalsVolumeData(selectedObj._id)
                        }
                        setFieldsValue({ volumeName: undefined, issues: undefined })
                        this.setState({ journalVolumeList: [], journalIssueList: [] })
                    }
                },
                {
                    label: 'Copies',
                    key: 'copies',
                    placeholder: 'Copies',
                    type: 'number'
                },
                {
                    label: 'Volume',
                    key: 'volumeName',
                    placeholder: 'Select',
                    type: 'select',
                    keyAccessor: x => x.name,
                    valueAccessor: x => x.name,
                    options: this.state.journalVolumeList,
                    onChange: async (selectedVolume) => {
                        setFieldsValue({ volumeName: selectedVolume })
                        // const selectedObj = this.state.journalVolumeList.find(x => x.name === selectedVolume)
                        // We need volume Name to find ID inside getJournalsIssueData
                        await this.getJournalsIssueData(selectedVolume)
                    }
                },
                {
                    label: 'Issue',
                    key: 'issues',
                    placeholder: 'Select',
                    type: 'select',
                    mode: 'multiple',
                    keyAccessor: x => x.name,
                    valueAccessor: x => x.name,
                    options: this.state.journalIssueList,
                    onChange: (e) => {
                        setFieldsValue({ issues: e })
                    }
                },
                {
                    key: 'add',
                    span: 4,
                    customField: (
                        <InputBox title={'Add'}>
                            <a className='btn mt10' type='primary'
                                onClick={() => {
                                    this.AddCourierDetails()
                                }}
                                style={{ backgroundColor: '#1556bc', textColor: 'white', color: 'white' }}>
                                ADD
                            </a>
                        </InputBox>
                    )
                }
            ]
        }

        const assignColumns = [
            {
                title: 'Journal Name',
                key: 'journal',
                dataIndex: 'journal',
                render: (text) => {
                    const item = this.state.journalNameList.find(j => j._id === text || j.name === text) // Handle both ID and Name
                    return <>{item ? item.name : text}</>
                }
            },
            {
                title: 'Volume',
                key: 'volumeName',
                dataIndex: 'volumeName'
            },
            {
                title: 'Issues',
                key: 'issues',
                dataIndex: 'issues',
                render: (item) => {
                    // item could be array or string if legacy
                    if (Array.isArray(item)) return item.join(', ')
                    return item
                }
            },
            {
                title: 'Copies',
                key: 'copies',
                dataIndex: 'copies'
            },
            {
                title: 'Action',
                key: 'action',
                dataIndex: 'action',
                render: (item, record, index) => {
                    return (
                        <Icon type={'close'}
                            style={{ color: 'red' }}
                            onClick={() => {
                                this.events.removeCourierDetail(index)
                            }} />
                    )
                }
            }
        ]

        return (
            <Drawer
                title={data && data.missingIssues ? 'Edit Missing Details' : 'Edit Courier Details'}
                width={'45%'}
                visible={visible}
                maskClosable={true}
                placement='right'
                onClose={onClose}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Card bordered={true}>
                                    <Row gutter={16}>
                                        {inputSchma.fields.map((item, key) => (
                                            !item.hidden && (
                                                <Col
                                                    span={item.span ? item.span : 8}
                                                    md={item.span ? item.span : 8}
                                                    sm={12}
                                                    xs={24}
                                                    key={key}>
                                                    <GetEachFormFields
                                                        item={item}
                                                        getFieldDecorator={getFieldDecorator}
                                                        formItemLayout={formItemLayout}
                                                    />
                                                </Col>
                                            )
                                        ))}
                                    </Row>
                                    <Row gutter={16}>
                                        {inputSchma.multiFields.map((item, key) => (
                                            !item.hidden && (
                                                <Col
                                                    span={item.span ? item.span : 6}
                                                    md={item.span ? item.span : 12}
                                                    sm={12}
                                                    xs={24}
                                                    key={key}>
                                                    {item.customField ? (
                                                        item.customField
                                                    ) : (
                                                        <GetEachFormFields
                                                            item={item}
                                                            getFieldDecorator={getFieldDecorator}
                                                            formItemLayout={formItemLayout}
                                                        />
                                                    )}
                                                </Col>
                                            )
                                        ))}
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Table
                                dataSource={this.state.courierDetails}
                                className={'table table-bordered'}
                                bordered={true}
                                size={'small'}
                                pagination={false}
                                columns={assignColumns}
                                rowKey={(record, index) => index}
                            />
                        </Row>

                        <Form.Item style={{ marginTop: 32 }}>
                            <Button type='primary' htmlType='submit' loading={this.state.loading}>
                                UPDATE
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

export default EditCourierDrawer